<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">HISTORIAL DE DECLARACIÓN DEL EXTRANJERO</h5>
        <div class="row mt-4">
          <div class="col-lg-4">
            <div class="form-group">
              <label>Tipo domicilio:</label>
              <select
                class="custom-select"
                v-model.trim="$v.tipo_domicilio.$model"
              >
                <option value="" selected>SELECCIONAR</option>
                <option value="HOS">HOSPEDAJE</option>
                <option value="RES">RESIDENCIA</option>
                <option value="ND">NO DECLARO REG. OPERADOR</option>
                <option value="NDP"> NO DECLARO REG. PROPIO</option>
              </select>
              <span
                class="text-danger lb-error"
                v-if="!$v.tipo_domicilio.required"
                >* Campo requerido</span
              >
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label>Departamento:</label>
              <select
                class="custom-select"
                v-model.trim="$v.parametro_dep.$model"
               
                :disabled="tipo_domicilio == 'NDP'"
              >
              
                <option value="" selected>SELECCIONAR</option>
                <option value="LA PAZ">LA PAZ</option>
                <option value="SANTA CRUZ">SANTA CRUZ</option>
                <option value="COCHABAMBA">COCHABAMBA</option>
                <option value="TARIJA">TARIJA</option>
                <option value="POTOSI">POTOSI</option>
                <option value="CHUQUISACA">CHUQUISACA</option>
                <option value="BENI">BENI</option>
                <option value="PANDO">PANDO</option>
                <option value="ORURO">ORURO</option>
              </select>
              <span
                class="text-danger lb-error"
                v-if="!$v.parametro_dep.required"
                >* Campo requerido</span
              >
            </div>
          </div>

          <div class="col-lg-4">
            <div class="form-group">
              <label>Tipo Registro:</label>
              <select
                class="custom-select"
                v-model.trim="$v.revisado.$model"
                :disabled="tipo_domicilio == 'NDP'"
              
              >
                <option value="" selected>SELECCIONAR</option>
                <option value="0" v-if="tipo_domicilio == 'ND'">NO DECLARA</option>
                <option value="1" v-if="tipo_domicilio !== 'ND'">DECLARA</option>
                <option value="2" v-if="tipo_domicilio !== 'ND'">HISTORICO</option>
                <option value="3" v-if="tipo_domicilio !== 'ND'">NO CONFIRMADOS 48 HORAS</option>
              </select>
              <span class="text-danger lb-error" v-if="!$v.revisado.required"
                >* Campo requerido</span
              >
            </div>
          </div>

          <div class="col-lg-3">
            <div class="form-group">
              <label>Fecha Inicio:</label>
              <input
                type="date"
                v-model.trim="$v.fecha_inicio.$model"
                class="form form-control"
              />
              <span
                class="text-danger lb-error"
                v-if="!$v.fecha_inicio.required"
                >* Campo requerido</span
              >
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label>Fecha Fin:</label>
              <input
                type="date"
                v-model.trim="$v.fecha_fin.$model"
                class="form form-control"
              />
              <span class="text-danger lb-error" v-if="!$v.fecha_fin.required"
                >* Campo requerido</span
              >
            </div>
          </div>
          <div
            class="col-lg-3"
            v-if="parametro_dep != '' && tipo_domicilio != '' && revisado != '' && tipo_domicilio != 'NDP'"
          >
            <label> </label>
            <div class="form-group">
            
              <button
                class="btn btn-info"
                type="button"
                @click="
                  buscarExtranjeroDepartamanto(
                    parametro_dep,
                    tipo_domicilio,
                    revisado,
                    fecha_inicio,
                    fecha_fin
                  )
                "
              >
                buscar
                <i class="fa fa-search"></i>
              </button>
              &nbsp;
              <button
                class="btn btn-secondary"
                type="button"
                @click="
                  limpiar()
                "
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>
          <div class="col-lg-3" v-if="tipo_domicilio == 'NDP'">
            <label> </label>
            <div class="form-group">
              <button
                class="btn btn-info"
                type="button"
                @click="buscarExtranjeroRegistroPropio(fecha_inicio, fecha_fin)"
              >
                buscar
                <i class="fa fa-search"></i>
              </button>
              &nbsp;
              <button
                class="btn btn-secondary"
                type="button"
                @click="
                  limpiar()
                "
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>
          <div
            class="col-lg-2"
            v-if="parametro_dep != '' && tipo_domicilio != '' && revisado != '' && tipo_domicilio != 'NDP'"
          >
            <label> </label>
            <div class="form-group">
              <button
                class="btn btn-success"
                type="button"
                @click="
                  exportarXls(
                    parametro_dep,
                    tipo_domicilio,
                    revisado,
                    fecha_inicio,
                    fecha_fin
                  )
                "
              >
                Excel
                <i class="fa fa-print"></i>
              </button>
            </div>
          </div>
          <div class="col-lg-2" v-if="tipo_domicilio == 'NDP'">
            <label> </label>
            <div class="form-group">
              <button
                class="btn btn-success"
                type="button"
                @click="exportarNoDeclaradosXls(fecha_inicio, fecha_fin)"
              >
                Excel
                <i class="fa fa-print"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="table-responsive mt-3"
            style="overflow-y:scroll; height:400px;"
          >
            <div
              class="alert alert-warning"
              role="alert"
              v-if="
                registrosEncontrados.length == 0 &&
                  (parametro_dep == '' ||
                    tipo_domicilio == '' ||
                    revisado == '')
              "
            >
              No se encontro ningún Registro
            </div>
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th>
                  <small class="font-weight-bold">FECHA NACIMIENTO</small>
                </th>
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">ACCIONES</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontrados" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombre_completo }}</small>
                </td>
                <td>
                  <small>
                    {{ item.per_numero_documento }} <br />
                    {{ item.tipo_documento }}
                  </small>
                </td>
                <td>
                  <small>{{
                    formatFecha(getDate(item.per_fecha_nacimiento))
                  }}</small>
                </td>
                <td>
                  <small>{{ item.nombre }}</small>
                </td>
                <!-- <td><small>{{ item.direccion }}</small></td> -->
                <td class="text-center">
                  <router-link
                    :to="{ name: 'mapeo', params: { id: item.id_persona } }"
                    class="btn btn-outline-info btn-sm mr-1"
                  >
                    <i class="fa fa-eye"></i>
                  </router-link>
                  <a
                    class="btn btn-outline-primary btn-sm mr-2"
                    title="Descargar"
                    :href="url + item.id_persona + '/' + item.id_domicilios"
                  >
                    <i class="fa fa-file"></i>
                  </a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "buscarExtranjero",
  components: {
    Loading,
  },
  data() {
    return {
      parametro: "",
      parametro_dep: "",
      tipo_domicilio: "",
      revisado: "",
      fecha_inicio: new moment().format("YYYY-MM-DD"),
      fecha_fin: new moment().format("YYYY-MM-DD"),
      registrosEncontrados: [],
      cargando: false,
      url: process.env.VUE_APP_URL + "/documento/3/",
    };
  },
  methods: {
    async buscarExtranjero(parametro) {
      try {
        let resultados = await this.axios.get(`/personaBuscar/${parametro}`);
        this.registrosEncontrados = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async buscarExtranjeroDepartamanto(
      parametro_dep,
      tipo_domicilio,
      revisado,
      fecha_inicio,
      fecha_fin
    ) {
      if (parametro_dep !== "" && tipo_domicilio !== "" && revisado !== "") {
        if(revisado==0){
          revisado=1;
        }
        try {
          let resultados = await this.axios.get(
            `/personaBuscaDepartamento/${parametro_dep}/${tipo_domicilio}/${revisado}/${fecha_inicio}/${fecha_fin}`
          );
          this.registrosEncontrados = resultados.data.contenido;
        } catch (error) {
          console.log("catch: ", error);
          this.$swal({
            title: "Información",
            text: "Ocurrio un Error al realizar la consulta!",
            type: "error",
            confirmButtonText: "Aceptar",
          });
        }
      }
      if (parametro_dep == "" && tipo_domicilio == "" && revisado == "") {
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
    async buscarExtranjeroRegistroPropio(fecha_inicio, fecha_fin) {
      if (this.tipo_domicilio !== "") {
        try {
          let resultados = await this.axios.get(
            `/noDeclaraUsuarioPropio/${fecha_inicio}/${fecha_fin}`
          );
          this.registrosEncontrados = resultados.data.contenido;
        } catch (error) {
          console.log("catch: ", error);
          this.$swal({
            title: "Información",
            text: "Ocurrio un Error al realizar la consulta!",
            type: "error",
            confirmButtonText: "Aceptar",
          });
        }
      }
      if (this.tipo_domicilio == "") {
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },

    async limpiar() {
      this.tipo_domicilio = ""; 
      this.parametro_dep = ""; 
      this.revisado ="";
    
      
    },
    async exportarXls(
      parametro_dep,
      tipo_domicilio,
      revisado,
      fecha_inicio,
      fecha_fin
    ) {
      let config = { headers: { token: this.token }, responseType: "blob" };
      this.cargando = true;
      try {
        if(revisado==0){
          revisado=1
        }
        let resultados = await this.axios.get(
          `/personasDepExcel/${parametro_dep}/${tipo_domicilio}/${revisado}/${fecha_inicio}/${fecha_fin}`,
          config
        );
        await this.crearDescarga(resultados, "reporte.xlsx");

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    async exportarNoDeclaradosXls(
      fecha_inicio,
      fecha_fin
    ) {
      let config = { headers: { token: this.token }, responseType: "blob" };
      this.cargando = true;
      try {
        let resultados = await this.axios.get(
          `/personasNoDeclararonExcel/${fecha_inicio}/${fecha_fin}`,
          config
        );
        await this.crearDescarga(resultados, "reporte.xlsx");

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
  },
  created() {},
  validations: {
    parametro_dep: { required },
    tipo_domicilio: { required },
    revisado: { required },
    fecha_inicio: { required },
    fecha_fin: { required },
  },
};
</script>
